import styled, { css } from 'styled-components';
import { HR } from '@zillow/zrs-comet';
import { token, spaceMixin, Text } from '@zillow/constellation';

export const StyledText = styled(Text)`
    && {
        ${props => css`
            ${props.bold && css`
                font-weight: bold;
            `}
        `}
    }
`;

export const StyledListingOverview = styled.div`
    /* account for no top HR on ListingStatus  */
    margin-bottom: -${spaceMixin('xs')};

    .Overview-Container {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }

    .Overview-Col {
        position: relative;
        padding: 0 ${spaceMixin('sm')};
        text-align: center;
        width: 33%;
    }

    ${HR}.HR-Divider {
        margin: ${spaceMixin('md')} 0;
        color: ${token('colors.gray400')};

        &:before, &:after {
            background: #ccc;
        }
    }

    ${HR}.HR-Divider.HR-Divider--top {
        margin-top: 0;
    }

    ${HR}.HR-Divider.HR-Divider--bottom {
        margin-bottom: 0;
    }
`;

export const StyledTriangle = styled.div`
    position: absolute;
    margin: 0 auto;
    top: -25px;
    left: 0;
    right: 0;
    width: 18px;
    height: 18px;
    background-color: ${token('colors.blue100')};
    transform: rotate(-45deg);
`;
